import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2ReportService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report.service';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { FiChecklist2ReportHelperService } from './services/fi-checklist2-report-helper.service';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { CdkDragHandle, DragDropModule } from '@angular/cdk/drag-drop';
import { FiAutoscrollOnDragModule } from '@fi-shared/fi-directives/fi-autoscroll-on-drag/fi-autoscroll-on-drag.module';
import { DndModule } from 'ngx-drag-drop';
import { FiChecklist2ReportFilterService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-filter.service';
import { FiChecklist2ReportHistoryService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-history.service';
import { FiChecklist2ReportComponent } from '@fi-shared/checklist/fi-checklist2-report/fi-checklist2-report.component';
import { FiChecklist2ReportRecentActivityService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-recent-activity.service';
import { FiChecklist2ReportChecklistHistoryModule } from '@fi-shared/checklist/fi-checklist2-report/components/checklist-history-report/checklist-history-report.module';
import { FiChecklist2ReportOpenChecklistModule } from '@fi-shared/checklist/fi-checklist2-report/components/open-checklists-report/open-checklists-report.module';
import { FiChecklist2ReportDeviationsModule } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviations-report.module';
import { FiChecklist2ReportNewWidgetDialogComponent } from '@fi-shared/checklist/fi-checklist2-report/components/new-widget-dialog/fi-checklist2-report-new-widget-dialog.component';
import { FiChecklist2ReportNewWidgetTypeSelectStepComponent } from '@fi-shared/checklist/fi-checklist2-report/components/new-widget-dialog/new-widget-type-select/new-widget-type-select.component';
import { FiChecklist2ReportNewWidgetDataFilterStepComponent } from '@fi-shared/checklist/fi-checklist2-report/components/new-widget-dialog/new-widget-filter-data-step/new-widget-data-filter-step.component';
import { FiChecklist2ReportDashboardComponent } from '@fi-shared/checklist/fi-checklist2-report/components/dashboard/fi-checklist2-report-dashboard.component';
import { FiChecklist2ReportWidgetDetailsComponent } from '@fi-shared/checklist/fi-checklist2-report/components/widget-details/fi-checklist2-report-widget-details.component';
import { MatDividerModule } from '@angular/material/divider';
import { FiRecentActivityReportModule } from '@fi-shared/checklist/fi-checklist2-report/components/recent-activity-report/recent-activity-report.module';
import { FiChecklist2ReportDialogsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-dialogs.service';
import { MatRippleModule } from '@angular/material/core';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FiChecklist2ReportStateService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-state.service';
import { FiChecklist2ReportDataService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-data.service';
import { FiChecklist2ReportOpenChecklistsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-open-checklists.service';
import { FiReportWidgetModule } from '@fi-shared/fi-report-widget/fi-report-widget.module';
import { FiChecklist2ReportNewWidgetDataFilterWrapperComponent } from './components/new-widget-dialog/new-widget-filter-data-step/new-widget-filter-data-wrapper/new-widget-filter-data-wrapper.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';

@NgModule({
    imports: [
        CommonModule,
        FiAutoscrollOnDragModule,
        DndModule,
        FiChecklist2ReportChecklistHistoryModule,
        FiProfileIconModule,
        MatIconModule,
        FiAppTextSharedModule,
        MatCardModule,
        CdkDragHandle,
        FiLocalSearch2Module,
        MatButtonModule,
        FiChecklist2ReportOpenChecklistModule,
        FiChecklist2ReportDeviationsModule,
        FiRecentActivityReportModule,
        MatDividerModule,
        MatRippleModule,
        FiValidatingFormModule,
        MatInputModule,
        FormsModule,
        DragDropModule,
        FiReportWidgetModule,
        FiLoadingModule,
    ],
    declarations: [
        FiChecklist2ReportDashboardComponent,
        FiChecklist2ReportComponent,
        FiChecklist2ReportWidgetDetailsComponent,
        FiChecklist2ReportNewWidgetDialogComponent,
        FiChecklist2ReportNewWidgetTypeSelectStepComponent,
        FiChecklist2ReportNewWidgetDataFilterStepComponent,
        FiChecklist2ReportNewWidgetDataFilterWrapperComponent,
    ],
    providers: [
        FiChecklist2ReportService,
        FiChecklist2ReportDialogsService,
        FiChecklist2ReportHelperService,
        FiChecklist2ReportFilterService,
        FiChecklist2ReportOpenChecklistsService,
        FiChecklist2ReportHistoryService,
        FiChecklist2ReportRecentActivityService,
        FiChecklist2ReportStateService,
        FiChecklist2ReportDataService,
    ],
})
export class FiChecklist2ReportModule {}
